import React from "react";
import Lottie from "react-lottie";
import animationData from "./data.json";

interface state {
	isStopped: boolean;
	isPaused: boolean;
}

export class LottieComponent03 extends React.Component<{}, state> {
	constructor(props: any) {
		super(props);
		this.state = { isStopped: false, isPaused: false };
	}

	render() {
		const defaultOptions = {
			loop: true,
			autoplay: true,
			animationData: animationData,
			rendererSettings: {
				preserveAspectRatio: "xMidYMid slice",
			},
		};

		return (
			<>
				<Lottie
					options={defaultOptions}
					height="100%"
					width="100%"
					isStopped={this.state.isStopped}
					isPaused={this.state.isPaused}
				/>
			</>
		);
	}
}
